import { gql } from "@apollo/client";

const GET_CLIENT_CONTACT_INFORMATION = gql`
  query getClientContactInformation($clientIdentifier: String!) {
    client(clientIdentifier: $clientIdentifier) {
      id
      identifier
      name
      addresses {
        legal {
          city
          co
          postalCode
          street
        }
        postal {
          city
          co
          postalCode
          street
        }
        visiting {
          city
          co
          postalCode
          street
        }
      }
      representatives {
        firstName
        lastName
        roles
        amlStatus {
          isPep
          isSanctioned
          sanctionDescription
          typeOfSanction
          updatedTimestamp
        }
        controlTypes
      }
      emailConnections {
        id
        emailAddress
      }
      contacts {
        name
        email
        phone
      }
    }
  }
`;

export default GET_CLIENT_CONTACT_INFORMATION;
